package org.dronda.app.web.client

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.accept
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType
import org.dronda.api.wishlist.AddWishlistItem
import org.dronda.api.wishlist.CreateWishList
import org.dronda.api.wishlist.EditWishlistItem
import org.dronda.api.wishlist.WishListFull

class WishlistClient(private val client: HttpClient) {

    suspend fun getWishlist(wishlistId: String): Result<WishListFull, Unit> {
        val response = client.get("/wl/wishlist/$wishlistId")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun createWishlist(request: CreateWishList): Result<Unit, Unit> {
        val response = client.post("/wl/wishlist") {
            setBody(request)
        }

        return if (response.status == HttpStatusCode.OK) {
            Ok(Unit)
        } else {
            Err(Unit)
        }
    }

    suspend fun addItem(wishlistId: String, item: AddWishlistItem): Result<Unit, Unit> {
        val response = client.post("/wl/wishlist/$wishlistId") {
            contentType(ContentType.Application.Json)
            setBody(item)
        }

        return if (response.status == HttpStatusCode.OK) {
            Ok(Unit)
        } else {
            Err(Unit)
        }
    }

    suspend fun updateItem(
        wishlistId: String,
        itemId: String,
        item: EditWishlistItem
    ): Result<WishListFull, Unit> {
        val response = client.put("/wl/wishlist/$wishlistId/item/$itemId") {
            contentType(ContentType.Application.Json)
            setBody(item)
        }

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun deleteItem(wishlistId: String, itemId: String): Result<Unit, Unit> {
        val response = client.delete("/wl/wishlist/$wishlistId/item/$itemId")

        return if (response.status == HttpStatusCode.OK) {
            Ok(Unit)
        } else {
            Err(Unit)
        }
    }

    suspend fun toggleItemPurchaseStatus(
        wishlistId: String,
        itemId: String
    ): Result<WishListFull, Unit> {
        val response = client.post("/wl/wishlist/$wishlistId/item/$itemId/purchase")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }
}
